import OperationsPageShell from '../components/OperationsPageShell';

const kpis = [
  { label: 'New orders', value: 124 },
  { label: 'Processed today', value: 94 },
  { label: 'Processed weight', value: '18.6t' },
  { label: 'Unplanned orders', value: 15 },
  { label: 'Overdue orders', value: 21 },
  { label: 'Vehicles available', value: 18 },
];

const OperationBoard = () => (
  <OperationsPageShell
    title="Operation Board"
    subtitle="Live operational work queues across planned and unplanned activities."
    action={
      <button type="button" className="uw-btn uw-btn-light uw-btn-sm btn btn-sm btn-light">
        ↻ Refresh
      </button>
    }
  >
    <div className="row g-5 mb-5">
      {kpis.map((kpi) => (
        <div key={kpi.label} className="col-md-2 col-sm-4 col-6">
          <div className="card border h-100">
            <div className="card-body text-center">
              <div className="text-muted small">{kpi.label}</div>
              <div className="fs-3 fw-bold mt-2">{kpi.value}</div>
            </div>
          </div>
        </div>
      ))}
    </div>

    <div className="row g-5">
      {['Unplanned orders', 'In progress', 'Broken down', 'Awaiting clearance'].map((section) => (
        <div key={section} className="col-lg-6">
          <div className="card border h-100">
            <div className="card-header border-0">
              <h5 className="mb-0">{section}</h5>
            </div>
            <div className="card-body">
              <ul className="list-group list-group-flush">
                <li className="list-group-item px-0">#OP-1012</li>
                <li className="list-group-item px-0">#OP-1043</li>
                <li className="list-group-item px-0">#OP-1060</li>
              </ul>
            </div>
          </div>
        </div>
      ))}
    </div>
  </OperationsPageShell>
);

export default OperationBoard;
